import { Button } from 'telia-front-react';
import { inject, observer } from 'mobx-react';
import * as React from 'react';

import AnalyticsService from '../../../services/AnalyticsService';
import PaymentHistoryStore from '../../../stores/PaymentHistoryStore';
import { ITranslateStore } from '../../../stores/TranslateStore';

interface IDownloadXlsxButtonProps {
  translateStore?: ITranslateStore;
  analyticsService?: AnalyticsService;
  paymentHistoryStore?: PaymentHistoryStore;
}

@inject('translateStore', 'analyticsService', 'paymentHistoryStore')
@observer
export default class DownloadXlsxButton extends React.Component<IDownloadXlsxButtonProps> {
  public render(): JSX.Element {
    const translate = this.props.translateStore.translate;
    const store = this.props.paymentHistoryStore;

    return (
      <Button
        id="payment-history-filter-export-xlsx"
        text={translate('payment-history.filter.download-xlsx')}
        iconLeft={store.fileStatus === 'error' ? '#alert' : '#download'}
        target="_blank"
        size="small"
        onClick={() => {
          store.downloadFile();
          this.props.analyticsService.paymentHistoryDownloadXlsx();
        }}
        isLoading={store.fileStatus === 'loading'}
      />
    );
  }
}
